// * Import 3rd party
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box, {})(({ theme, customProps }) => ({}));

export default StyledBox;
